import { defineComponent as _defineComponent } from 'vue'
import dataService from '@/services/data.service';
import * as bench32 from 'bech32';
import { ref } from "vue";
import { object, string } from "yup";
import i18n from "@/plugins/i18n";
import {Field, Form} from "vee-validate";
import { useConfigurationStore } from '@/store/configuration.store';
import { YupSequentialStringSchema } from '@/utils/yup-utils';



export default /*#__PURE__*/_defineComponent({
  __name: 'LoginAddress',
  emits: ['close'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

// import LoginChoose from '@/components/layout/loginPopup/LoginChoose.vue'
const emit = __emit;
const address = ref('');
let errorMessageType = '';

async function validateAddress(address: string | undefined){
  console.log('validateAddress: ' + address);
  if (!address) {
    errorMessageType = i18n.global.t('CONNECT.ADDRESS_VALIDATION.EMPTY');
    return false;
  }
  try {
    const words = bench32.decode(address);
    if(words?.prefix !== useConfigurationStore().config.addressPrefix){
      errorMessageType = i18n.global.t('CONNECT.ADDRESS_VALIDATION.NOT_THIS_NETWORK', {prefix: useConfigurationStore().config.addressPrefix});
    }
    return true;
  } catch (err) {
    onWrongAddress(address, String(err));
    return false;
  }
}
const amountSchema = object().shape({
  address: YupSequentialStringSchema([
      string().required(i18n.global.t('CONNECT.ADDRESS_VALIDATION.EMPTY')),
      string().test('validate Address', i18n.global.t('CONNECT.ADDRESS_VALIDATION.NOT_THIS_NETWORK', {prefix: useConfigurationStore().config.addressPrefix}), (address: string | undefined) => {
        if (!address) {
          return false;
        }
        return address.startsWith(useConfigurationStore().config.addressPrefix);
      }),
      string().test('validate Address', i18n.global.t(errorMessageType), validateAddress)
  ])
});

function onWrongAddress(address: string, err: string) {
  console.log(err.slice(7));
  switch (err.slice(7)){
    case address + ' too short' || 'Data too short':
      errorMessageType = i18n.global.t('CONNECT.ADDRESS_VALIDATION.TOO_SHORT');
      break;
    case 'No separator character for '+ address:
      errorMessageType = i18n.global.t('CONNECT.ADDRESS_VALIDATION.SEPARATOR');
      break;
    case 'Invalid checksum for '+ address:
      errorMessageType = i18n.global.t('CONNECT.ADDRESS_VALIDATION.CHECK_SUM');
      break;
    default:
      errorMessageType = i18n.global.t('CONNECT.ADDRESS_VALIDATION.INVALID');
      break;
  }
}

async function submit(){
    dataService.onAddressLogIn((address.value), () => {
      emit('close');
    });
}


const __returned__ = { emit, address, get errorMessageType() { return errorMessageType }, set errorMessageType(v) { errorMessageType = v }, validateAddress, amountSchema, onWrongAddress, submit, get Field() { return Field }, get Form() { return Form } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})